import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * FAST mode (FRU-21170): make browser / 1Password autofill "stick" on Angular
 * reactive-form fields wrapped by input directives (digitOnly zip, IMask phone).
 *
 * The provider fills the DOM value, but for these fields the FormControl never
 * registers it (no clean input event through the wrapping directive), so Angular
 * treats the field as empty/invalid. This directive detects the fill (the
 * :-webkit-autofill CSS animation hook + change/input/blur) and pushes the DOM
 * value into the FormControl so validation + the lead payload get it.
 */
@Directive({
  selector: '[autofillSync]',
  standalone: false,
})
export class AutofillSyncDirective {
  constructor(private el: ElementRef<HTMLInputElement>, @Optional() private ngControl: NgControl) {}

  @HostListener('animationstart', ['$event'])
  onAnimationStart(e: AnimationEvent): void {
    // Fired by the :-webkit-autofill keyframe (see styles) when Chrome silently fills.
    if (e && e.animationName === 'fruOnAutoFill') {
      this.sync();
    }
  }

  // 1Password / Chrome dispatch these after filling.
  @HostListener('change') onChange(): void { this.sync(); }
  @HostListener('blur') onBlur(): void { this.sync(); }
  @HostListener('input') onInput(): void { this.sync(); }

  private sync(): void {
    const domValue = this.el.nativeElement.value;
    if (!this.ngControl || !this.ngControl.control) { return; }
    if (domValue != null && this.ngControl.control.value !== domValue) {
      this.ngControl.control.setValue(domValue);
      this.ngControl.control.markAsDirty();
      this.ngControl.control.updateValueAndValidity();
    }
  }
}
